import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { GoldDivider } from './GoldDivider';
const BOOKS_IMG = 'https://cdn.magicpatterns.com/uploads/bhFSrSEpMQzWKRAtD8S14k/Fotografa_de_producto_de_ultra_Nano_Banana_2_93471.jpg';
interface TomoData {
  emoji: string;
  num: number;
  title: string;
  subtitle: string;
  pages: number;
  description: string;
  features: string[];
  value: string;
  color: string;
}
const tomos: TomoData[] = [{
  emoji: '🟡',
  num: 1,
  title: 'EL INTERRUPTOR',
  subtitle: 'Manual de Desactivación del Piloto Automático',
  pages: 60,
  color: 'border-yellow-500/20',
  description: 'La técnica de 60 segundos para desactivar el patrón automático que te mantiene atrapado. Basado en el Método Silva adaptado para uso inmediato.',
  features: ['Diagnóstico de tu tipo de piloto automático', 'Técnica del Interruptor de 60 segundos', 'Protocolo de reprogramación de emergencia', 'Tu estado magnético personal activado'],
  value: '$5.990'
}, {
  emoji: '🟣',
  num: 2,
  title: 'INGENIERÍA DE GUION',
  subtitle: 'El Scripting de Realidad',
  pages: 60,
  color: 'border-purple-500/20',
  description: 'Por qué la visualización sola falla en el 91% de casos y cómo los 5 Guiones Maestros listos para usar lo solucionan hoy.',
  features: ['Los 5 Guiones Maestros completos y personalizables', 'Las 3 ventanas óptimas de scripting', 'La técnica del Revisionista Cuántico', 'Tu protocolo de scripting de 24H'],
  value: '$5.990'
}, {
  emoji: '🟢',
  num: 3,
  title: 'EL VACÍO CUÁNTICO',
  subtitle: 'Técnicas de Desapego Flash',
  pages: 60,
  color: 'border-emerald-500/20',
  description: 'El secreto que nadie explica: cuanto más necesitás el resultado, más lo alejás. 5 técnicas de desapego que toman entre 60 segundos y 5 minutos.',
  features: ['Las 5 Técnicas Flash de Desapego', 'El calendario de desapego de 21 días', 'La diferencia exacta entre desapego y resignación', 'Las 7 señales de que tu manifestación está próxima'],
  value: '$5.990'
}, {
  emoji: '🔴',
  num: 4,
  title: 'EL CUERPO MAGNÉTICO',
  subtitle: 'Sintonización Celular',
  pages: 60,
  color: 'border-red-500/20',
  description: 'El 85% de los practicantes ignoran esto: tu campo electromagnético se extiende hasta 4 metros fuera de vos. Tu cuerpo es el transmisor más poderoso del sistema.',
  features: ['Los 5 Protocolos de Sintonización Celular', 'Plan nutricional de alta frecuencia de 7 días', 'Rutina de movimiento de 20 minutos diarios', 'Coherencia cardíaca como estado de manifestación'],
  value: '$5.990'
}, {
  emoji: '🌙',
  num: 5,
  title: 'EL GUARDIÁN DEL SUEÑO',
  subtitle: 'Protocolo de Pre-Sueño',
  pages: 60,
  color: 'border-indigo-400/20',
  description: 'Las 8 horas de sueño son las más poderosas del proceso. La mayoría las desperdicia. Este tomo te da el protocolo exacto para programar tu subconsciente mientras dormís.',
  features: ['Las 5 Técnicas Nocturnas del sistema', 'El Teatro Mental de Neville en estado hipnagógico', 'El calendario de 21 noches de programación', 'El protocolo del Despertar Consciente'],
  value: '$5.990'
}];
interface BonoData {
  num: number;
  title: string;
  subtitle: string;
  pages: number;
  description: string;
  features: string[];
  value: string;
}
const bonos: BonoData[] = [{
  num: 1,
  title: 'EL RADAR DE SINCRONÍAS',
  subtitle: 'Checklist de Señales',
  pages: 30,
  description: 'El universo te responde constantemente. Este bono te da el checklist de los 7 tipos de sincronías con instrucciones exactas de cómo responder a cada una.',
  features: ['55+ señales catalogadas y explicadas', 'Cómo responder correctamente a cada señal', 'Las 48 horas doradas antes de la materialización', 'Plantilla de registro de 21 días'],
  value: '$3.990'
}, {
  num: 2,
  title: 'GUIONES DE AUTO-HIPNOSIS',
  subtitle: 'Textos de Reprogramación Profunda',
  pages: 30,
  description: 'Tu propia voz es 10 veces más poderosa que cualquier audio externo. 10 guiones completos para leer, grabar y activar tu subconsciente en estado Theta.',
  features: ['10 guiones de 400+ palabras listos para usar', 'Protocolo de inducción hipnótica en 5 pasos', 'Guía para grabar tus propios audios', 'Calendario semanal de guiones'],
  value: '$3.990'
}, {
  num: 3,
  title: 'EL PLAN DE 21 DÍAS',
  subtitle: 'Tu Mapa Completo de Implementación',
  pages: 30,
  description: 'Sabés exactamente qué hacer en cada momento de los próximos 21 días. Sin adivinar. Sin improvisar. Con checklists diarios y protocolo de emergencia incluido.',
  features: ['Plan día a día con checklists marcables', 'Protocolo de Emergencia del Día 11', 'El Ritual Completo del Día 21', 'Plan de mantenimiento post-21 días'],
  value: '$3.990'
}];
function TomoCard({
  tomo
}: {
  tomo: TomoData;
}) {
  return <div className={`border ${tomo.color} bg-white/[0.02] rounded-xl p-6 md:p-8`} data-id="element-192">
      <div className="flex items-center gap-3 mb-1" data-id="element-193">
        <span className="text-2xl" data-id="element-194">{tomo.emoji}</span>
        <p className="text-brand-gold font-body text-sm font-semibold uppercase tracking-widest" data-id="element-195">
          Tomo {tomo.num}
        </p>
      </div>
      <h3 className="font-heading text-xl md:text-2xl text-brand-ivory font-bold mt-2" data-id="element-196">
        {tomo.title}
      </h3>
      <p className="text-brand-gold/80 font-body font-medium text-sm mt-1" data-id="element-197">
        {tomo.subtitle}
      </p>
      <p className="text-brand-muted-dark font-body text-sm italic mt-1" data-id="element-198">
        {tomo.pages} páginas
      </p>
      <p className="text-brand-muted font-body text-base leading-relaxed mt-4" data-id="element-199">
        {tomo.description}
      </p>
      <div className="mt-5 space-y-2.5" data-id="element-200">
        {tomo.features.map((f, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-201">
            <span className="text-brand-gold text-sm mt-0.5 shrink-0" data-id="element-202">✓</span>
            <p className="text-brand-ivory/80 font-body text-sm" data-id="element-203">{f}</p>
          </div>)}
      </div>
      <p className="text-brand-muted font-body text-sm font-semibold mt-5" data-id="element-204">
        Valor: <span className="text-brand-ivory" data-id="element-205">{tomo.value}</span>
      </p>
    </div>;
}
function BonoCard({
  bono
}: {
  bono: BonoData;
}) {
  return <div className="border border-brand-gold/15 bg-brand-gold/[0.03] rounded-xl p-6 md:p-8" data-id="element-206">
      <div className="flex items-center gap-3 mb-1" data-id="element-207">
        <span className="text-xl" data-id="element-208">⭐</span>
        <p className="text-brand-gold font-body text-sm font-semibold uppercase tracking-widest" data-id="element-209">
          Bono {bono.num}
        </p>
      </div>
      <h3 className="font-heading text-xl md:text-2xl text-brand-ivory font-bold mt-2" data-id="element-210">
        {bono.title}
      </h3>
      <p className="text-brand-gold/80 font-body font-medium text-sm mt-1" data-id="element-211">
        {bono.subtitle}
      </p>
      <p className="text-brand-muted-dark font-body text-sm italic mt-1" data-id="element-212">
        {bono.pages} páginas
      </p>
      <p className="text-brand-muted font-body text-base leading-relaxed mt-4" data-id="element-213">
        {bono.description}
      </p>
      <div className="mt-5 space-y-2.5" data-id="element-214">
        {bono.features.map((f, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-215">
            <span className="text-brand-gold text-sm mt-0.5 shrink-0" data-id="element-216">✓</span>
            <p className="text-brand-ivory/80 font-body text-sm" data-id="element-217">{f}</p>
          </div>)}
      </div>
      <p className="text-brand-muted font-body text-sm font-semibold mt-5" data-id="element-218">
        Valor: <span className="text-brand-ivory" data-id="element-219">{bono.value}</span>
      </p>
    </div>;
}
export function ProductSection() {
  return <SectionWrapper bgColor="bg-brand-black" className="relative" data-id="element-220">
      {/* Books background behind title area */}
      <div className="absolute inset-x-0 top-0 h-[500px] bg-center bg-no-repeat bg-cover opacity-[0.12] pointer-events-none" style={{
      backgroundImage: `url(${BOOKS_IMG})`,
      backgroundPosition: 'center 45%',
      maskImage: 'linear-gradient(to bottom, black 20%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black 20%, transparent 100%)'
    }} data-id="element-221" />

      <div className="relative" data-id="element-222">
        <p className="text-brand-muted text-center text-base md:text-lg font-body" data-id="element-223">
          Presentando:
        </p>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-brand-gold text-center font-bold mt-4" data-id="element-224">
          PROTOCOLO 24H: SALTO CUÁNTICO
        </h2>

        <p className="font-heading text-lg md:text-xl text-brand-ivory/80 text-center mt-4 italic" data-id="element-225">
          5 Tomos + 3 Bonos — 390 páginas — Acceso inmediato
        </p>

        <div className="mt-10" data-id="element-226">
          <GoldDivider data-id="element-227" />
        </div>

        <p className="text-brand-gold font-body text-sm uppercase tracking-[0.2em] text-center mt-10 mb-6" data-id="element-228">
          📚 Los 5 Tomos
        </p>

        <div className="space-y-6" data-id="element-229">
          {tomos.map(tomo => <TomoCard key={tomo.num} tomo={tomo} data-id="element-230" />)}
        </div>

        <div className="mt-14" data-id="element-231">
          <GoldDivider data-id="element-232" />
        </div>

        <p className="text-brand-gold font-body text-sm uppercase tracking-[0.2em] text-center mt-10 mb-6" data-id="element-233">
          🎁 Los 3 Bonos
        </p>

        <div className="space-y-6" data-id="element-234">
          {bonos.map(bono => <BonoCard key={bono.num} bono={bono} data-id="element-235" />)}
        </div>
      </div>
    </SectionWrapper>;
}